import { useEffect } from "react";

const setMetaTag = (nameOrProperty, content, isProperty = false) => {
  if (!content) return;

  let tag = document.querySelector(
    isProperty
      ? `meta[property='${nameOrProperty}']`
      : `meta[name='${nameOrProperty}']`
  );

  if (!tag) {
    tag = document.createElement("meta");
    if (isProperty) tag.setAttribute("property", nameOrProperty);
    else tag.setAttribute("name", nameOrProperty);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const useSEO = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  twitterCard = "summary_large_image",
  twitterTitle,
  twitterDescription,
  twitterImage
}) => {
  useEffect(() => {
    if (title) document.title = title;

    setMetaTag("description", description);
    setMetaTag("keywords", keywords);

    // Open Graph
    setMetaTag("og:title", ogTitle || title, true);
    setMetaTag("og:description", ogDescription || description, true);
    setMetaTag("og:image", ogImage, true);

    // Twitter
    setMetaTag("twitter:card", twitterCard);
    setMetaTag("twitter:title", twitterTitle || title);
    setMetaTag("twitter:description", twitterDescription || description);
    setMetaTag("twitter:image", twitterImage);
  }, [
    title,
    description,
    keywords,
    ogTitle,
    ogDescription,
    ogImage,
    twitterCard,
    twitterTitle,
    twitterDescription,
    twitterImage
  ]);
};

export default useSEO;
